export const checklistData = [
  {
    id: 1,
    title: "¿Qué servicio estás mostrando?",
    explanation: "Tu publicación debe dejar claro qué trabajo hiciste. No asumas que la persona entiende la foto.",
    checkboxes: [
      "El post menciona el servicio específico.",
      "El servicio se entiende sin tener que adivinar.",
      "La foto o video muestra trabajo real.",
      "El texto evita frases vagas como “otro trabajo terminado”."
    ],
    prompt: "Actúa como un asistente de marketing local. Mi negocio es de [tipo de negocio]. Hicimos este servicio: [servicio]. Ayúdame a escribir un caption claro para Facebook, Instagram y Google Business Profile. Quiero que sea simple, útil y fácil de entender para un dueño de casa.",
    example: {
      bad: "Otro trabajo terminado. Llámenos.",
      good: "Reparación de drywall en una casa después de daño por humedad. Antes de pintar, revisamos que la causa del problema estuviera controlada."
    }
  },
  {
    id: 2,
    title: "¿Qué problema resolviste?",
    explanation: "Las personas buscan soluciones. Explica el problema que tenía el cliente antes del trabajo.",
    checkboxes: [
      "El post menciona el problema inicial.",
      "Explica por qué ese problema importaba.",
      "Ayuda a otro cliente a reconocer una situación parecida.",
      "No revela información privada del cliente."
    ],
    prompt: "Convierte este trabajo en una publicación educativa. El problema del cliente era: [problema]. El servicio que hicimos fue: [servicio]. Dame 3 formas de explicar este problema para que un homeowner entienda cuándo debe pedir ayuda profesional.",
    example: {
      text: "Si ves manchas en el techo, no siempre es solo pintura vieja. Puede ser señal de humedad o una fuga que debe revisarse primero."
    }
  },
  {
    id: 3,
    title: "¿Dónde trabajas?",
    explanation: "Si es apropiado compartirlo, menciona la ciudad o área de servicio de forma natural. No llenes el post de palabras clave.",
    checkboxes: [
      "El post menciona la ciudad o área cuando tiene sentido.",
      "La ubicación suena natural.",
      "El área mencionada es realmente un lugar donde trabajas.",
      "El post ayuda a clientes locales a entender si les puedes servir."
    ],
    prompt: "Revisa este caption y mejora la parte local. Quiero mencionar [ciudad o área] de forma natural, sin sonar forzado ni lleno de palabras clave. El servicio es [servicio] y el cliente tenía este problema: [problema].",
    example: {
      text: "Pintura exterior en Vallejo: antes de aplicar pintura nueva, preparamos la superficie para que el acabado dure más."
    }
  },
  {
    id: 4,
    title: "¿Por qué deberían confiar?",
    explanation: "No tienes que decir “somos los mejores”. Muestra experiencia explicando tu proceso, cuidado y criterio.",
    checkboxes: [
      "El post explica una parte del proceso.",
      "Muestra cuidado, preparación o revisión.",
      "Incluye un tip útil.",
      "Evita promesas exageradas.",
      "Si aplica, menciona licencia, seguro, garantía, experiencia o reseñas de forma natural."
    ],
    prompt: "Mejora este caption para que genere más confianza sin sonar exagerado. Quiero que explique el proceso, el cuidado y el resultado. Mantén el tono profesional, claro y natural para clientes locales.",
    example: {
      text: "Antes de recomendar reemplazo, revisamos el sistema para entender si el problema venía del equipo, ductos, filtros o mantenimiento."
    }
  },
  {
    id: 5,
    title: "¿Qué puede aprender el cliente?",
    explanation: "Una publicación útil no solo muestra el resultado. También enseña algo que ayuda al cliente a tomar mejores decisiones.",
    checkboxes: [
      "El post incluye una recomendación práctica.",
      "Responde una pregunta común.",
      "Ayuda al cliente a evitar un error.",
      "Explica cuándo conviene llamar a un profesional."
    ],
    prompt: "De este proyecto, saca una lección útil para un dueño de casa. Dame 5 ideas de posts educativos basados en este trabajo: [describe el trabajo]. Quiero ideas simples para Facebook, Instagram, TikTok y Google Business Profile.",
    example: {
      text: "No pintes encima de daño por humedad sin revisar la causa. Puedes esconder el problema, pero no resolverlo."
    }
  },
  {
    id: 6,
    title: "¿Qué debe hacer la persona después?",
    explanation: "Cada publicación necesita un siguiente paso claro. No siempre tiene que ser vender. Puede ser comentar, guardar, mandar mensaje o pedir una revisión.",
    checkboxes: [
      "El post tiene una llamada a la acción.",
      "El CTA suena natural.",
      "La persona sabe cómo contactarte.",
      "El CTA está alineado con el tipo de post."
    ],
    prompt: "Dame 5 llamadas a la acción naturales para este post. No quiero que suenen agresivas. Quiero opciones para una persona que puede necesitar este servicio pronto o que quiere guardar la información para después.",
    example: {
      list: [
        "Guarda este tip si estás planeando reparar o remodelar tu casa.",
        "Mándanos mensaje si tienes una situación parecida.",
        "Comenta qué pregunta tienes sobre este tipo de servicio.",
        "Agenda una revisión si necesitas ayuda con tu proyecto."
      ]
    }
  }
];